import { axios } from "../axios.instance";

export type UnadmireUserRequest = {
  userId: string;
};

export type UnadmireUserResponse = object;

export const unadmireUser = async (body: UnadmireUserRequest): Promise<UnadmireUserResponse> => {
  const { data } = await axios.post(`/admires/${body.userId}/unadmire`);

  return data;
};
